<button [ngClass]="classes" [disabled]="disabled" (click)="handleClick($event)">
  <!-- Standard and Ghost Variants -->
  <ng-container *ngIf="variant === 'standard' || variant === 'ghost'">
    <!-- Icon Position -->
    <span class="btn-icon-wrapper" *ngIf="icon">
      <hyperkit-icon
        [icon]="icon!"
        [size]="'small'"
        [color]="'inherit'"
      ></hyperkit-icon>
    </span>

    <!-- Button Text -->
    <span class="btn-text" *ngIf="text">
      <hyperkit-typography [variant]="size === 'small' ? 'button2' : 'button1'"
      [color]="'inherit'">
        {{ text }}
      </hyperkit-typography>
    </span>
  </ng-container>

  <!-- Icon Variant -->
  <ng-container *ngIf="variant === 'icon'">
    <span class="btn-icon-wrapper">
      <hyperkit-icon
        [icon]="icon!"
        [size]="'small'"
        [color]="'inherit'"
      ></hyperkit-icon>
    </span>
  </ng-container>

  <!-- Link Variant -->
  <ng-container *ngIf="variant === 'link'">
    <span class="btn-text" *ngIf="text">
      <hyperkit-typography [variant]="size === 'small' ? 'button2' : 'button1'"
      [color]="'inherit'">
        {{ text }}
      </hyperkit-typography>
    </span>
  </ng-container>

  <!-- Collapsable Variant -->
  <ng-container *ngIf="variant === 'collapsable'">
    <span class="btn-text" *ngIf="text">
      <hyperkit-typography [variant]="size === 'small' ? 'button2' : 'button1'"
      [color]="'inherit'">
        {{ text }}
      </hyperkit-typography>
    </span>

    <span class="btn-icon-wrapper">
      <hyperkit-icon
        [icon]="icon!"
        [size]="'medium'"
        color="inherit"
        [ngClass]="{ expanded: isExpanded }"
      ></hyperkit-icon>
    </span>
  </ng-container>
</button>
